import Link, { Props as LinkProps } from 'components/Link';
import * as React from 'react';

import cx from 'classnames';
import './styles/MenuItem.scss';

export type Props = {
  href?: string;
  to?: string;
  onSelect?: (arg0: any) => any;
  onClick?: (arg0: React.MouseEvent) => any;
  // XXX this is whack typing
  // `selected` can take `true`, `false`, and `null`. When `true` or `false', the
  // item is considered "selectable" and will render a checkmark when checked.
  selected?: boolean | null;
  disabled?: boolean;
  // Used by Menu
  menuKey: any;
  eventScreenName?: string;
  eventElementName?: string;
  eventProperties?: object;
  eventKey?: string;
  className?: string;
} & Partial<LinkProps>;

class MenuItem extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    selected: null,
  };

  handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (this.props.disabled) {
      event.preventDefault();
    }

    if (this.props.disabled) {
      return;
    }

    if (this.props.selected) {
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.menuKey);
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  render() {
    const { className, ...others } = this.props;

    return (
      <li
        className={cx(
          'MenuItem',
          {
            'MenuItem--selectable': typeof this.props.selected === 'boolean',
            'MenuItem--selected': !!this.props.selected,
            'MenuItem--disabled': this.props.disabled,
          },
          className
        )}>
        <Link
          {...others}
          // @ts-ignore
          color={!this.props.selected && 'thunder'}
          className="MenuItem-link"
          eventScreenName={this.props.eventScreenName}
          eventElementName={this.props.eventElementName}
          eventProperties={this.props.eventProperties}
          onClick={this.handleClick}>
          {this.props.children}
        </Link>
      </li>
    );
  }
}

export default MenuItem;
